<section>
  <app-head-generative-ai selectedNavItem="data"></app-head-generative-ai>

  <div class="container m-b-xxl m-t-alt">
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-10-tablet is-8-desktop">
        <h2 class="title is-2 mb-0">Data</h2>
        <div *ngIf="page?.content" [innerHTML]="page.content"></div>
        <div *ngIf="!page">
          <div
            class="mt-6 temporary-item temporary-item--dark temporary-desc"
          ></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div
            class="temporary-item temporary-item--dark temporary-item--block"
          ></div>
        </div>
      </div>
      <div class="column is-12">
        <app-data-visualization-panel
          *ngIf="area"
          [area]="area"
          [selectedVisualizationFiltersHash]="visualizationFiltersHash"
          [isSourcesExtendable]="true"
        ></app-data-visualization-panel>
        <p class="small-meta mb-4" *ngIf="area">
          NOTE: It is important to highlight that data sources and methodologies
          may differ from those used in OECD research, and therefore results may
          vary. As such, this section includes full and transparent
          methodological information. Because methods for measuring AI are still
          evolving, there remain definitional and other issues that can
          influence empirical results. Efforts to develop clear definitions,
          taxonomies and classifications are underway, as are efforts to compile
          accurate and comparable indicators. Given the current evolving
          situation, showing trends in a timely manner based on transparent
          methodologies by partner institutions can be of value to policy
          makers.
        </p>
      </div>
    </div>
    <ng-container *ngIf="!loader && featuredCards.length">
      <div class="columns">
        <div
          class="column is-12-mobile is-12-tablet is-9-desktop is-9-widescreen"
        >
          <h2 class="title is-2 mb-0">Other data resources</h2>
        </div>
      </div>
      <div class="columns is-multiline">
        <div
          class="column is-4-tablet is-3-desktop"
          *ngFor="let featuredCard of featuredCards"
        >
          <app-featured-card [featuredCard]="featuredCard"></app-featured-card>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="loader">
      <div class="columns is-multiline">
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop">
          <div class="lc lc--regular">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
